import View from './FormResetPassword';
import enhancer from './FormResetPassword.enhancer';

const FormResetPassword = enhancer(View);

export default FormResetPassword;
